export const APP_HEALTH_CHECK_INTERVAL = 10; // 10 sec
export const FAULTS_AUTO_REFRESH_INTERVAL = 300; // 300 sec
export const APP_HEALTH_CHECK_TIMEOUT = 15; // 15 sec
export const KIOSK_MODE_AUTO_REFRESH_INTERVAL = 60; // 60 sec
export const EXPAND_NETWORK_PULSE_INTERVAL = KIOSK_MODE_AUTO_REFRESH_INTERVAL * 1000; // msec
